<template>
  <div>
    <vs-table
      :max-items="descriptionItems[0]"
      pagination
      :data="childs"
      description
      search
      :description-items="descriptionItems"
      description-title="Registries"
      description-connector="of"
      description-body="Pages"
      @selected="handleSelected"
    >
      <template slot="header" v-if="isChild">
        <span class="vx-col order-1">
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            class="truncate"
            @click="handleChildPopup"
            size="small"
            >{{ $t("customers.label.add_Child") }}</vs-button
          >
        </span>
      </template>
      <template slot="thead">
        <vs-th>{{ $t("customers.label.account_number") }}</vs-th>
        <vs-th>{{ $t("customers.label.name") }}</vs-th>
        <vs-th>{{ $t("customers.label.email") }}</vs-th>
        <vs-th>{{ $t("customers.label.cell_phone") }}</vs-th>
        <vs-th v-if="isChild">{{ $t("customers.label.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="index" :data="child" v-for="(child, index) in data">
          <vs-td :data="child.accountNo">{{ child.accountNo }}</vs-td>
          <vs-td :data="child.name">{{ child.name }}</vs-td>
          <vs-td :data="child.emailId">{{ child.emailId }}</vs-td>
          <vs-td :data="child.mobileNumber">{{ child.mobileNumber }}</vs-td>
          <vs-td class="whitespace-no-wrap" v-if="isChild">
            <div class="container_img">
              <feather-icon
                icon="EyeIcon"
                :title="$t('setup.label.View')"
                svgClasses="w-5 h-5 stroke-current cursor text-primary"
                @click.stop="openView(child.accountNo.slice(-4))"
                class="icon_row"
              />
              <feather-icon
                icon="XIcon"
                :title="$t('setup.label.Delete')"
                svgClasses="w-5 h-5 text-danger stroke-current cursor"
                @click.stop="
                  (delId = child.accountNo.slice(-4)),
                    (deleteTicketPopup = true)
                "
                class="icon_row"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.add_Child')"
        :active.sync="childPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer3">
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 my-5">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.SelectCustomerType")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.SelectCustomerType')"
                  :key="resetKey"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="type"
                    :options="customerTypes"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    @input="handleTypeChanges"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </ValidationObserver>
        <div style="height: 100px"></div>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.existing_customer')"
        :active.sync="existingChildPopup"
        class="popup-close"
      >
        <div
          class="vx-col sm:w-full md:w-full mb-1 header--customerlist md:w-10"
        >
          <ul class="horizontal-sm-btn flex gap-3 mb-2">
            <li>
              <div class="cursor-pointer font-small w-full mt-1">
                <v-select
                  label="text"
                  v-model="searchOption"
                  :reduce="(obj) => obj.value"
                  :placeholder="$t('customers.label.SelectType')"
                  :options="searchItems"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-100 w-full"
                />
              </div>
            </li>
            <li>
              <div
                class="cursor-pointer flex items-center font-small w-full mt-1"
              >
                <vs-input
                  type="text"
                  class="w-100 search-inp"
                  icon-pack="feather"
                  icon="icon-search"
                  :disabled="!searchOption"
                  icon-no-border
                  :placeholder="SearchPlaceholder"
                  @keyup.enter="searchCustomer"
                  v-model="search"
                />
              </div>
            </li>
            <li>
              <div
                class="cursor-pointer flex items-center font-small w-full mt-1"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-search"
                  @click="searchCustomer"
                >
                  {{ $t("customers.label.search") }}
                </vs-button>
              </div>
            </li>
          </ul>
        </div>
        <vs-table
          v-if="customerExists"
          :max-items="10"
          pagination
          :data="getCustomers"
          @selected="handleSelected"
        >
          <template slot="thead">
            <vs-th>{{ $t("customers.label.account_no") }}</vs-th>
            <vs-th>{{ $t("customers.label.customer_name") }}</vs-th>
            <vs-th>{{ $t("entity.label.mobile_number") }}</vs-th>
            <vs-th>{{ $t("customers.label.type") }}</vs-th>
            <vs-th>{{ $t("customers.label.status") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="customer"
              v-for="(customer, index) in data"
              :class="{ 'selected-row': selectedChild === customer.id }"
            >
              <vs-td :data="customer.accountNo">{{ customer.accountNo }}</vs-td>

              <vs-td :data="customer.displayName">{{
                customer.displayName || customer.firstname
              }}</vs-td>
              <vs-td :data="customer.officeName">{{
                customer.officeName
              }}</vs-td>
              <vs-td :data="customer.hwSerialNumber">{{
                customer.hwSerialNumber
              }}</vs-td>
              <vs-td :data="customer.status.value">
                <vs-chip
                  :color="getOrderStatusColor(customer.status.value)"
                  class="product-order-status"
                  >{{ customer.status.value }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="vx-row justify-center my-4" v-if="customerExists">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addChild">
            {{ $t("customers.label.add_Child") }}
          </vs-button>
        </div>
        <div style="height: 100px"></div>
      </vs-popup>
    </div>
    <delete-popup
      :deletePopup="deleteTicketPopup"
      :title="'Child'"
      @deletePressed="deleteItem(delId)"
      @cancelPressed="deleteTicketPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    clientId: {
      type: [String, Number],
      required: false,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      deleteTicketPopup: false,
      search: "",
      delId: "",
      selectedChild: "",
      searchOption: "",
      toggleData: false,
      searchItems: [
        { text: this.$t("customers.label.AccountNo"), value: "account_no" },
        { text: this.$t("MSISDN"), value: "serial_no" },
        { text: this.$t("customers.label.EmailId"), value: "email" },
        { text: this.$t("Contact No"), value: "phone" },
      ],
      customerExists: false,
      customerTypes: [
        {
          id: "New Customer",
          mCodeValue: "New Customer",
        },
        {
          id: "Existing Customer",
          mCodeValue: "Existing Customer",
        },
        {
          id: "P to P Customer",
          mCodeValue: "P to P Customer",
        },
        {
          id: "MNP Customer",
          mCodeValue: "MNP Customer",
        },
      ],
      type: "",
      descriptionItems: [5, 10, 15],
      childPopup: false,
      existingChildPopup: false,
      resetKey: 0,
    };
  },
  computed: {
    ...mapState({
      childDetails: (state) => state.customerMoreInfo.childDetails,
      parentDetails: (state) => state.customerMoreInfo.parentDetails,
      addChildResponse: (state) => state.customerMoreInfo.addChildResponse,
      customerListToggleValue: (state) => state.settings.isCustomerListActive,
    }),
    SearchPlaceholder() {
      if (this.searchOption === "account_no") {
        return this.$t("customers.label.account_no");
      } else if (this.searchOption === "phone") {
        return this.$t("customers.label.mobile_no");
      } else if (this.searchOption === "email") {
        return this.$t("customers.label.email_id");
      } else if (this.searchOption === "serial_no") {
        return this.$t("customers.label.msisdn");
      } else return this.$t("customers.label.searchclient");
    },
    childs() {
      return this.isChild ? this.childDetails: this.parentDetails || [];
    },
    getCustomers() {
      return this.$store.getters["customer/getClientsList"];
    },
  },
  watch: {
    existingChildPopup(newVal) {
      if (!newVal) {
        this.resetExistingCustomerPopupData();
      }
    },
    searchOption() {
      this.searchdata = "";
      if (this.customerListToggleValue == true) {
        this.getCustomer(this.search);
      }
    },
    "$route.params.id": {
      immediate: true,
      handler() {
        this.getDetails();
      },
    },
  },
  methods: {
    openView(id) {
      this.$router.push(`/customers/view_customer/${id}`);
    },
    async deleteItem(item) {
      try {
        this.deleteTicketPopup = true;
        await this.$store.dispatch(
          "customerMoreInfo/removeChildFromFamilyPlanAction",
          {
            childClientId: item,
            parentClientId: this.$route.params.id,
          }
        );
        this.deleteTicketPopup = false;
        this.getDetails();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Child Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handleSelected(item) {
      this.selectedChild = item.id;
    },
    getOrderStatusColor(status) {
      if (status === "Inactive") return "dark";
      if (status === "New") return "warning";
      return "success";
    },
    async getDetails() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getParentDetailsByChildAction",
          this.$route.params.id
        );
        await this.$store.dispatch(
          "customerMoreInfo/getChildListByParentAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handleChildPopup() {
      this.resetKey += 1;
      this.type = "";
      this.existingChildPopup = false;
      this.childPopup = true;
    },
    handleTypeChanges() {
      if (this.type === "Existing Customer") {
        this.resetExistingCustomerPopupData();
        this.searchOption = "";
        this.search = "";
        this.customerExists = false;
        this.CLEAR_CLIENTS_LIST();
        this.existingChildPopup = true;
        this.childPopup = false;
      }
    },
    formatAccountNumber(accountInput) {
      let inputStr = accountInput.toString();
      if (inputStr.substring(0, 3).toUpperCase() === "CR-") {
        return inputStr;
      }
      const totalDigits = 9;

      let paddedNumber = inputStr.padStart(totalDigits, "0");
      return "CR-" + paddedNumber;
    },
    ...mapMutations("customer", ["CLEAR_CLIENTS_LIST"]),

    resetExistingCustomerPopupData() {
      this.search = "";
      this.searchOption = "";
      this.selectedChild = "";
      this.customerExists = false;
      this.CLEAR_CLIENTS_LIST();
    },
    async searchCustomer(event) {
      try {
        const payload = {
          type: this.searchOption,
          val: this.search.trim(),
        };
        if (this.searchOption === "account_no") {
          payload.val = this.formatAccountNumber(this.search.trim());
        }
        await this.$store.dispatch("customer/setCustomerSearch", payload);
        this.customerExists = true;
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "warning",
          html: "<div style='text-align:center;'>Unfortunately, we couldn't find a match with the given information.</div>",
          type: "warning",
        });
      }
      if (
        event &&
        event.key === "Backspace" &&
        this.customerListToggleValue == true
      ) {
        this.getCustomer(this.search);
      }
      if (
        event &&
        event.key === "Backspace" &&
        this.customerListToggleValue == false
      ) {
        this.CLEAR_CLIENTS_LIST();
      }
      if (this.customerListToggleValue == false) {
        this.CLEAR_CLIENTS_LIST();
      }
    },
    async getCustomer(queryParams) {
      try {
        this.$store.dispatch(
          "customer/setClient",
          _.pickBy(queryParams, _.identity)
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addChild() {
      const payload = {
        childClientId: this.selectedChild,
        parentClientId: this.$route.params.id,
      };
      try {
        await this.$store.dispatch(
          "customerMoreInfo/addChildToFamilyPlanAction",
          payload
        );
        this.existingChildPopup = false;
        this.getDetails();
        if (this.addChildResponse && this.addChildResponse.resourceIdentifier) {
          this.$swal({
            title: "Error",
            icon: "error",
            text: this.addChildResponse.resourceIdentifier.replace(/^Exception:\s*/, ''),
            type: "error",
          });
        } else if (this.addChildResponse && this.addChildResponse.clientId) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Child Added Successfully!",
            type: "success",
          });
        } else {
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Something Went Wrong!",
            type: "error",
          });
        }
        this.existingChildPopup = false;
        this.getDetails();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header--customerlist .vs-con-input-label {
  padding-top: 0px;
}
.search-inp {
  margin-top: 0px !important;
}
.vs-input--input.hasIcon:not(.icon-after-input) + .vs-input--placeholder {
  padding-left: 2.5rem !important;
  font-size: 13px;
  letter-spacing: 0.005em;
  color: #777777;
  font-weight: 400;
}
.search-inp div span {
  color: #000;
}
.selected-row {
  background-color: #e0f7fa !important;
  transition: background-color 0.3s ease;
}
</style>
